export const USER_ROLE = {
    notLogged: 'not-logged',
    subscribedUser: 'subscribed-user',
    subscriptionPending: 'subscription-pending',
    subscriptionExpired: 'subscription-expired',
    noRole: 'no-role',
};
const acceptedRoles = ['subscribed-user', 'subscription-pending'];
export function hasValidSchweizmobilPlusRole(roles) {
    return roles?.some((tested) => acceptedRoles.includes(tested));
}
export const REASON = {
    notLogged: 'not-logged',
    invalidRole: 'invalid-role',
    notOwner: 'not-owner',
    subscriptionExpired: USER_ROLE.subscriptionExpired,
    noRole: 'no-role',
};
//# sourceMappingURL=helper-users.js.map